const INITIAL_STATE = {
  invalidCode: false,
}

export default function invalidCodeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_INVALID_CODE':
      return {
        ...state,
        invalidCode: action.invalidCode,
      }
    default:
      return state;
  }
}
